var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 90,
    viewBox: "0 0 93 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2683 88.5236C59.3076 87.717 65.9144 79.6994 65.0192 70.6655C64.7513 67.8099 63.7564 65.1892 62.2573 62.9551L46.6562 -0.00081122L33.6307 65.5645C32.5859 68.0301 32.1135 70.7551 32.3815 73.6107C33.2171 82.6365 41.229 89.3302 50.2683 88.5236ZM47.726 61.9566C53.3649 61.4473 58.3451 65.5778 58.8887 71.2295C59.4323 76.8811 55.3396 81.844 49.7007 82.3534C44.0618 82.8627 39.0816 78.7322 38.538 73.0805C37.9607 67.4547 42.0871 62.466 47.726 61.9566Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueVector);
export default __webpack_public_path__ + "static/media/blue-vector.43c102a8a82609cf73f1237e39775305.svg";
export { ForwardRef as ReactComponent };